import { createSlice } from '@reduxjs/toolkit'


const user = JSON.parse(localStorage.getItem("_bnac"));
const initialState = {
  user: user ? user : null
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.user = action.payload
    },
    setUserImage: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, profileImage: action.payload };
        const existingUser = JSON.parse(localStorage.getItem("_bnac"));
        if (existingUser) {
          const updatedUser = {
            ...existingUser,
            profileImage: action.payload
          };

          localStorage.setItem("_bnac", JSON.stringify(updatedUser));
        }
      }
    },
  },
})

// Action creators are generated for each case reducer function
export const { setUserDetails, setUserImage } = userSlice.actions

export default userSlice.reducer